var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignHomeLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 403,
    viewBox: "0 0 270 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4609 256.722V231.337H33.9056V256.118L11.8204 276.97L11.6648 323.66L2.6441 332.575V373.071L27.0623 396.794L28.151 395.736L4.19941 372.315V333.18L13.3757 324.265V277.725L35.4609 256.722Z",
    fill: "url(#paint0_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7443 395.282V352.672L37.9494 322.602V292.08L67.189 263.522V165.003L43.5485 141.885V109.247H41.9932V142.489L65.6337 165.608V262.917L36.2386 291.475V323.207L67.189 353.276V395.282H68.7443Z",
    fill: "url(#paint1_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2074 168.781V101.843L78.0761 90.0566V41.704H76.3653V90.661L88.4966 102.447V168.025L47.1256 208.369V269.717L18.3526 297.671V372.013L31.2616 384.403V396.793H32.8169V383.799L20.0634 371.408V298.275L48.8365 270.321V208.974L90.2074 168.781Z",
    fill: "url(#paint2_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.258 308.852V281.503L158.33 253.549V217.889L76.9874 138.863V109.7H75.4321V139.467L156.774 218.493V254.153L185.547 282.107V308.852H187.258Z",
    fill: "url(#paint3_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8952 342.397V302.657L80.5646 286.64V199.303H77.2984V288L93.6291 304.017V341.188L72.7881 361.436V396.794H76.0542V362.796L96.8952 342.397Z",
    fill: "url(#paint4_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.068 273.041V209.88H125.513V272.286L105.294 291.929V360.378L92.2293 373.071V399.362H93.7846V373.675L106.849 360.982L107.005 292.684L127.068 273.041Z",
    fill: "url(#paint5_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.93 317.767V289.813L95.4954 230.128V191.446L125.046 162.737V68.7513L141.377 52.7345V30.2203H138.111V51.5257L121.78 67.5425V161.528L92.2293 190.086V231.488L153.819 291.173V316.558L140.599 329.251V398.909H143.865V330.611L156.93 317.767Z",
    fill: "url(#paint6_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.153 281.654V178.451L100.472 131.156V76.1553L97.2063 76.3064V132.365L146.043 179.811V280.445L123.18 302.506V396.794H126.446V303.866L149.153 281.654Z",
    fill: "url(#paint7_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.507 64.9738V30.2203H158.952V64.3694L135 87.6391V154.879H136.555V88.3946L160.507 64.9738Z",
    fill: "url(#paint8_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.918 374.128V254.002L191.769 220.004V158.657L167.039 134.632V110.304H165.484V135.236L190.213 159.261V220.609L225.207 254.607V373.373L203.122 394.98V402.535H204.677V395.585L226.918 374.128Z",
    fill: "url(#paint9_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 354.183V252.944L259.269 242.518V187.517L185.392 115.744V18.8876L200.167 4.53291L199.078 3.3241L183.681 18.2832V116.348L257.558 188.122V243.123L268.445 253.549L268.289 353.578L260.202 361.436V401.024H261.912V362.04L270 354.183Z",
    fill: "url(#paint10_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.567 172.86V89.9055H199.856V172.256L168.595 202.628V311.572L132.978 346.174V399.362H134.689V346.779L170.305 312.328V203.383L201.567 172.86Z",
    fill: "url(#paint11_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6832 234.359C36.5496 234.359 37.9493 232.999 37.9493 231.186C37.9493 229.373 36.5496 228.013 34.6832 228.013C32.8168 228.013 31.4171 229.373 31.4171 231.186C31.4171 232.999 32.8168 234.359 34.6832 234.359Z",
    fill: "url(#paint12_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9263 112.42C44.7927 112.42 46.1924 111.06 46.1924 109.247C46.1924 107.433 44.7927 106.073 42.9263 106.073C41.06 106.073 39.6602 107.433 39.6602 109.247C39.6602 111.06 41.06 112.42 42.9263 112.42Z",
    fill: "url(#paint13_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9874 113.477C78.6982 113.477 80.2535 112.118 80.2535 110.304C80.2535 108.491 78.8538 107.131 76.9874 107.131C75.121 107.131 73.7213 108.491 73.7213 110.304C73.7213 112.118 75.121 113.477 76.9874 113.477Z",
    fill: "url(#paint14_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.729 33.8466C161.44 33.8466 162.995 32.4867 162.995 30.6735C162.995 28.8603 161.596 27.5004 159.729 27.5004C157.863 27.5004 156.463 28.8603 156.463 30.6735C156.463 32.4867 157.863 33.8466 159.729 33.8466Z",
    fill: "url(#paint15_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.778 157.901C137.644 157.901 139.044 156.542 139.044 154.728C139.044 152.915 137.644 151.555 135.778 151.555C133.911 151.555 132.512 152.915 132.512 154.728C132.512 156.542 133.911 157.901 135.778 157.901Z",
    fill: "url(#paint16_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.951 113.931C167.817 113.931 169.217 112.571 169.217 110.758C169.217 108.944 167.817 107.584 165.951 107.584C164.084 107.584 162.684 108.944 162.684 110.758C162.684 112.571 164.084 113.931 165.951 113.931Z",
    fill: "url(#paint17_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.392 119.673C187.103 119.673 188.658 118.313 188.658 116.499C188.658 114.686 187.258 113.326 185.392 113.326C183.525 113.326 182.126 114.686 182.126 116.499C182.126 118.313 183.525 119.673 185.392 119.673Z",
    fill: "url(#paint18_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.085 255.967C158.952 255.967 160.351 254.607 160.351 252.793C160.351 250.98 158.952 249.62 157.085 249.62C155.219 249.62 153.819 250.98 153.819 252.793C153.819 254.607 155.219 255.967 157.085 255.967Z",
    fill: "url(#paint19_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.294 295.253C107.005 295.253 108.56 293.893 108.56 292.08C108.56 290.267 107.005 288.907 105.294 288.907C103.583 288.907 102.028 290.267 102.028 292.08C102.028 293.893 103.427 295.253 105.294 295.253Z",
    fill: "url(#paint20_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4114 168.479C68.2777 168.479 69.6775 167.119 69.6775 165.305C69.6775 163.492 68.2777 162.132 66.4114 162.132C64.545 162.132 63.1452 163.492 63.1452 165.305C63.1452 167.119 64.545 168.479 66.4114 168.479Z",
    fill: "url(#paint21_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.824 213.205C127.69 213.205 129.09 211.845 129.09 210.032C129.09 208.218 127.69 206.858 125.824 206.858C124.113 206.858 122.558 208.218 122.558 210.032C122.558 211.845 123.957 213.205 125.824 213.205Z",
    fill: "url(#paint22_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.835 223.782C192.702 223.782 194.101 222.422 194.101 220.609C194.101 218.795 192.702 217.436 190.835 217.436C189.124 217.436 187.569 218.795 187.569 220.609C187.569 222.422 188.969 223.782 190.835 223.782Z",
    fill: "url(#paint23_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.207 257.478C227.074 257.478 228.474 256.118 228.474 254.304C228.474 252.491 227.074 251.131 225.207 251.131C223.341 251.131 221.941 252.491 221.941 254.304C221.941 256.118 223.341 257.478 225.207 257.478Z",
    fill: "url(#paint24_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.856 6.34616C201.722 6.34616 203.122 4.98623 203.122 3.173C203.122 1.35978 201.722 -0.00012207 199.856 -0.00012207C197.99 -0.00012207 196.59 1.35978 196.59 3.173C196.59 4.98623 197.99 6.34616 199.856 6.34616Z",
    fill: "url(#paint25_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.478 93.532C202.189 93.532 203.744 92.1721 203.744 90.3589C203.744 88.5456 202.345 87.1857 200.478 87.1857C198.767 87.1857 197.212 88.5456 197.212 90.3589C197.212 92.1721 198.612 93.532 200.478 93.532Z",
    fill: "url(#paint26_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.547 309.91C187.414 309.91 188.813 308.55 188.813 306.737C188.813 304.924 187.414 303.564 185.547 303.564C183.681 303.564 182.281 304.924 182.281 306.737C182.281 308.55 183.681 309.91 185.547 309.91Z",
    fill: "url(#paint27_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8514 376.697C94.7178 376.697 96.1176 375.337 96.1176 373.524C96.1176 371.711 94.7178 370.351 92.8514 370.351C90.9851 370.351 89.5853 371.711 89.5853 373.524C89.5853 375.337 90.9851 376.697 92.8514 376.697Z",
    fill: "url(#paint28_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.528 206.103C171.394 206.103 172.794 204.743 172.794 202.93C172.794 201.116 171.394 199.757 169.528 199.757C167.661 199.757 166.262 201.116 166.262 202.93C166.262 204.743 167.661 206.103 169.528 206.103Z",
    fill: "url(#paint29_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9033 211.845C49.7697 211.845 51.1694 210.485 51.1694 208.672C51.1694 206.858 49.7697 205.499 47.9033 205.499C46.1925 205.499 44.6372 206.858 44.6372 208.672C44.6372 210.334 46.0369 211.845 47.9033 211.845Z",
    fill: "url(#paint30_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7535 280.898C14.6199 280.898 16.0197 279.538 16.0197 277.725C16.0197 275.912 14.6199 274.552 12.7535 274.552C10.8872 274.552 9.48743 275.912 9.48743 277.725C9.48743 279.538 10.8872 280.898 12.7535 280.898Z",
    fill: "url(#paint31_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26621 336.202C5.13256 336.202 6.53232 334.842 6.53232 333.028C6.53232 331.366 5.13256 329.855 3.26621 329.855C1.39985 329.855 6.10352e-05 331.215 6.10352e-05 333.028C6.10352e-05 334.842 1.39985 336.202 3.26621 336.202Z",
    fill: "url(#paint32_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42175 375.79C5.13258 375.79 6.6879 374.43 6.6879 372.617C6.6879 370.804 5.28811 369.444 3.42175 369.444C1.5554 369.444 0.15564 370.804 0.15564 372.617C0.15564 374.43 1.5554 375.79 3.42175 375.79Z",
    fill: "url(#paint33_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6637 375.035C20.53 375.035 21.9298 373.675 21.9298 371.862C21.9298 370.048 20.3745 368.688 18.6637 368.688C16.9528 368.688 15.3975 370.048 15.3975 371.862C15.3975 373.675 16.7973 375.035 18.6637 375.035Z",
    fill: "url(#paint34_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3272 325.776C39.1936 325.776 40.5934 324.416 40.5934 322.602C40.5934 320.789 39.1936 319.429 37.3272 319.429C35.4609 319.429 34.0611 320.789 34.0611 322.602C34.0611 324.416 35.4609 325.776 37.3272 325.776Z",
    fill: "url(#paint35_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4114 266.393C68.2777 266.393 69.6775 265.033 69.6775 263.219C69.6775 261.406 68.2777 260.046 66.4114 260.046C64.545 260.046 63.1452 261.406 63.1452 263.219C63.1452 265.033 64.545 266.393 66.4114 266.393Z",
    fill: "url(#paint36_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2984 45.6327C79.1648 45.6327 80.5646 44.2727 80.5646 42.4595C80.5646 40.6463 79.1648 39.2864 77.2984 39.2864C75.4321 39.2864 74.0323 40.6463 74.0323 42.4595C74.0323 44.2727 75.4321 45.6327 77.2984 45.6327Z",
    fill: "url(#paint37_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7616 80.9905C101.25 80.9905 103.272 79.0262 103.272 76.6085C103.272 74.1909 101.25 72.2266 98.7616 72.2266C96.2731 72.2266 94.2512 74.1909 94.2512 76.6085C94.2512 79.0262 96.2731 80.9905 98.7616 80.9905Z",
    fill: "url(#paint38_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0093 204.139C81.4977 204.139 83.5196 202.174 83.5196 199.757C83.5196 197.339 81.4977 195.224 79.0093 195.224C76.5208 195.224 74.4989 197.188 74.4989 199.757C74.4989 202.325 76.5208 204.139 79.0093 204.139Z",
    fill: "url(#paint39_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1648 292.08C81.6533 292.08 83.6752 290.116 83.6752 287.698C83.6752 285.28 81.6533 283.316 79.1648 283.316C76.6763 283.316 74.6544 285.28 74.6544 287.698C74.6544 290.116 76.6763 292.08 79.1648 292.08Z",
    fill: "url(#paint40_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.133 33.9979C142.621 33.9979 144.643 32.0336 144.643 29.6159C144.643 27.1983 142.621 25.234 140.133 25.234C137.644 25.234 135.622 27.1983 135.622 29.6159C135.622 32.0336 137.644 33.9979 140.133 33.9979Z",
    fill: "url(#paint41_linear_14_1266)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4344 242.367V223.48H60.1902V241.763L43.8595 257.326V291.778L37.0162 298.426V328.344L55.2132 345.872L55.9909 345.117L38.2605 327.891V298.879L45.1038 292.231V257.78L61.4344 242.367Z",
    fill: "url(#paint42_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0081 344.663V313.234L63.1452 291.022V268.508L84.9194 247.354V174.371L67.3445 157.448V133.272H66.1003V157.901L83.6752 174.976V246.9L62.0565 267.904V291.475L84.7639 313.687V344.663H86.0081Z",
    fill: "url(#paint43_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.872 177.242V127.681L92.8514 119.068V83.257H91.7627V119.521L100.628 128.285V176.789L69.9885 206.556V251.887L48.6809 272.588V327.589L58.3238 336.806V345.872H59.4125V336.202L49.9252 326.984V273.041L71.2328 252.34V207.009L101.872 177.242Z",
    fill: "url(#paint44_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.571 280.747V260.651L152.264 239.95V213.507L92.0738 155.03V133.574H90.8296V155.484L151.02 213.96V240.403L172.483 261.104V280.747H173.571Z",
    fill: "url(#paint45_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.849 305.679V276.214L94.7178 264.428V199.908L92.2293 199.757V265.335L104.516 277.272V304.772L88.9632 319.731V345.872H91.4517V320.789L106.849 305.679Z",
    fill: "url(#paint46_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09 254.304V207.614H128.001V253.851L113.07 268.357V318.976L103.272 328.344V347.836H104.516V328.798L114.159 319.429V268.81L129.09 254.304Z",
    fill: "url(#paint47_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.331 287.547V266.846L105.76 222.573V194.015L127.535 172.861V103.203L139.666 91.4166V74.6443H137.333V90.51L125.202 102.296V171.803L103.272 193.108V223.631L148.842 267.753V286.489L139.199 296.009V347.383H141.532V296.915L151.331 287.547Z",
    fill: "url(#paint48_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.576 260.802V184.495L109.493 149.44V108.793H107.005V150.346L143.088 185.402V259.744L126.29 276.214V345.872H128.623V277.121L145.576 260.802Z",
    fill: "url(#paint49_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.975 100.483V74.6443H152.73V100.029L135 117.255V166.968H136.089V117.708L153.975 100.483Z",
    fill: "url(#paint50_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.967 329.1V240.252L176.993 215.169V169.687L158.641 152.008V134.027H157.552V152.462L175.749 170.292V215.622L201.722 240.705V328.647L185.392 344.512V350.103H186.636V344.966L202.967 329.1Z",
    fill: "url(#paint51_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.85 314.443V239.496L226.918 231.79V191.144L172.172 137.956V66.4847L183.214 55.7565L182.437 55.001L171.083 65.8803V138.56L225.674 191.597V232.244L233.606 239.95V313.839L227.696 319.731V349.045H228.785V320.185L234.85 314.443Z",
    fill: "url(#paint52_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.148 180.264V118.917H183.059V179.811L159.885 202.325V282.863L133.6 308.399V347.836H134.689V309.003L161.129 283.467V202.779L184.148 180.264Z",
    fill: "url(#paint53_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8123 225.746C62.0565 225.746 63.3007 224.688 63.1452 223.48C63.1452 222.271 62.0565 221.062 60.8123 221.213C59.568 221.213 58.4793 222.271 58.4793 223.48C58.4793 224.688 59.568 225.746 60.8123 225.746Z",
    fill: "url(#paint54_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8779 135.538C68.2777 135.538 69.2109 134.481 69.2109 133.272C69.2109 132.063 68.1221 131.005 66.8779 131.005C65.6337 131.005 64.545 132.063 64.545 133.272C64.545 134.481 65.6337 135.538 66.8779 135.538Z",
    fill: "url(#paint55_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0738 136.294C93.318 136.294 94.4067 135.236 94.4067 134.027C94.4067 132.818 93.318 131.761 92.0738 131.761C90.8295 131.761 89.7408 132.818 89.7408 134.027C89.7408 135.236 90.8295 136.294 92.0738 136.294Z",
    fill: "url(#paint56_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.353 77.3641C154.597 77.3641 155.686 76.3064 155.686 75.0976C155.686 73.8888 154.597 72.8311 153.353 72.8311C151.953 72.8311 151.02 73.8888 151.02 75.0976C151.02 76.3064 152.108 77.3641 153.353 77.3641Z",
    fill: "url(#paint57_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.467 169.234C136.866 169.234 137.8 168.176 137.955 166.967C137.955 165.608 136.866 164.701 135.467 164.701C134.067 164.701 133.134 165.759 133.134 166.967C133.134 168.176 134.222 169.234 135.467 169.234Z",
    fill: "url(#paint58_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.863 136.747C159.263 136.747 160.196 135.689 160.196 134.481C160.196 133.272 159.107 132.214 157.863 132.214C156.463 132.214 155.53 133.272 155.53 134.481C155.53 135.689 156.619 136.747 157.863 136.747Z",
    fill: "url(#paint59_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.172 140.978C173.571 140.978 174.505 139.92 174.505 138.711C174.505 137.503 173.416 136.294 172.172 136.294C170.927 136.294 169.839 137.352 169.839 138.711C169.839 140.071 170.927 140.978 172.172 140.978Z",
    fill: "url(#paint60_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.331 241.763C152.73 241.763 153.664 240.705 153.664 239.496C153.664 238.288 152.575 237.23 151.331 237.23C150.086 237.23 148.998 238.288 148.998 239.496C148.998 240.856 150.086 241.914 151.331 241.914V241.763Z",
    fill: "url(#paint61_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.07 270.775C114.47 270.775 115.403 269.717 115.403 268.357C115.403 266.997 114.315 266.09 113.07 266.09C111.826 266.09 110.737 267.148 110.737 268.357C110.737 269.566 111.826 270.775 113.07 270.775Z",
    fill: "url(#paint62_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2973 176.94C85.6971 176.94 86.6302 175.883 86.6302 174.674C86.6302 173.465 85.5415 172.407 84.2973 172.256C83.0531 172.256 81.9644 173.314 81.9644 174.674C81.9644 176.034 83.0531 176.94 84.2973 176.94Z",
    fill: "url(#paint63_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.157 210.032C129.401 210.032 130.49 208.974 130.49 207.765C130.49 206.556 129.401 205.499 128.157 205.499C126.757 205.499 125.824 206.556 125.824 207.765C125.824 208.974 126.912 210.032 128.157 210.032Z",
    fill: "url(#paint64_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.371 217.889C177.615 217.889 178.704 216.831 178.704 215.622C178.704 214.414 177.615 213.356 176.371 213.356C175.127 213.356 174.038 214.414 174.038 215.622C174.038 216.831 175.127 217.889 176.371 217.889Z",
    fill: "url(#paint65_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.722 242.821C203.122 242.821 204.211 241.763 204.055 240.554C204.055 239.345 202.967 238.136 201.722 238.136C200.478 238.136 199.389 239.194 199.389 240.554C199.389 241.914 200.478 242.821 201.722 242.821Z",
    fill: "url(#paint66_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.059 57.1164C184.303 57.1164 185.392 56.0587 185.392 54.8499C185.392 53.6411 184.303 52.5834 183.059 52.5834C181.659 52.5834 180.726 53.6411 180.726 54.8499C180.726 56.0587 181.815 57.1164 183.059 57.1164Z",
    fill: "url(#paint67_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.37 121.637C184.614 121.637 185.703 120.579 185.703 119.37C185.703 118.162 184.614 117.104 183.37 117.104C181.97 117.104 181.037 118.162 181.037 119.37C181.037 120.579 182.126 121.637 183.37 121.637Z",
    fill: "url(#paint68_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.483 281.503C173.883 281.503 174.816 280.445 174.816 279.236C174.816 278.027 173.727 276.97 172.483 276.97C171.239 276.97 170.15 278.027 170.15 279.236C170.15 280.445 171.239 281.503 172.483 281.503Z",
    fill: "url(#paint69_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.894 331.064C105.294 331.064 106.227 330.006 106.227 328.798C106.227 327.438 105.138 326.531 103.894 326.531C102.65 326.531 101.561 327.589 101.561 328.798C101.561 330.006 102.65 331.064 103.894 331.064Z",
    fill: "url(#paint70_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.507 204.894C161.751 204.894 162.84 203.836 162.84 202.627C162.84 201.419 161.751 200.21 160.351 200.21C158.952 200.21 158.018 201.268 158.018 202.476C158.018 203.685 159.107 204.743 160.351 204.743L160.507 204.894Z",
    fill: "url(#paint71_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6107 208.974C71.8549 208.974 72.9436 207.916 72.9436 206.707C72.9436 205.498 71.8549 204.441 70.6107 204.441C69.3664 204.441 68.2777 205.498 68.2777 206.707C68.2777 207.916 69.3664 209.125 70.6107 209.125V208.974Z",
    fill: "url(#paint72_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6372 260.197C45.8814 260.197 46.9701 259.14 46.9701 257.931C46.9701 256.722 45.8814 255.664 44.6372 255.664C43.2374 255.664 42.1487 256.722 42.3042 257.931C42.3042 259.14 43.3929 260.197 44.6372 260.197Z",
    fill: "url(#paint73_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6383 300.995C39.0381 300.995 39.9712 299.937 39.9712 298.728C39.9712 297.52 38.8825 296.462 37.6383 296.462C36.3941 296.462 35.3054 297.52 35.3054 298.728C35.3054 299.937 36.3941 300.995 37.6383 300.995Z",
    fill: "url(#paint74_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6383 330.46C39.0381 330.46 39.9712 329.402 39.9712 328.193C39.9712 326.984 38.8825 325.927 37.6383 325.927C36.3941 325.927 35.3054 326.984 35.3054 328.193C35.3054 329.553 36.3941 330.46 37.6383 330.46Z",
    fill: "url(#paint75_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.992 329.855C50.3918 329.855 51.3249 328.798 51.3249 327.589C51.3249 326.38 50.2362 325.322 48.992 325.322C47.7478 325.322 46.6591 326.38 46.6591 327.589C46.6591 328.798 47.7478 330.006 48.992 330.006V329.855Z",
    fill: "url(#paint76_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6786 293.289C64.0784 293.289 65.0116 292.231 65.0116 291.022C65.0116 289.813 63.9229 288.756 62.6786 288.756C61.4344 288.756 60.3457 289.813 60.3457 291.022C60.3457 292.231 61.4344 293.289 62.6786 293.289Z",
    fill: "url(#paint77_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2973 249.469C85.6971 249.469 86.6302 248.411 86.6302 247.203C86.6302 245.994 85.5415 244.936 84.2973 244.936C83.0531 244.936 81.9644 245.994 81.9644 247.203C81.9644 248.411 83.0531 249.469 84.2973 249.469Z",
    fill: "url(#paint78_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2293 86.1279C93.6291 86.1279 94.7178 85.0702 94.5622 83.8614C94.5622 82.6526 93.4735 81.5948 92.2293 81.5948C90.9851 81.5948 89.8964 82.6526 89.8964 83.8614C89.8964 85.0702 90.9851 86.1279 92.2293 86.1279Z",
    fill: "url(#paint79_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.249 112.269C110.115 112.269 111.671 110.758 111.671 108.944C111.671 107.131 110.115 105.62 108.249 105.62C106.383 105.62 104.827 107.131 104.827 108.944C104.827 110.758 106.383 112.269 108.249 112.269Z",
    fill: "url(#paint80_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6291 203.383C95.4954 203.383 97.0507 201.872 97.0507 200.059C97.0507 198.246 95.4954 196.734 93.6291 196.734C91.7627 196.734 90.3629 198.246 90.3629 200.059C90.3629 201.872 91.9183 203.383 93.7846 203.383H93.6291Z",
    fill: "url(#paint81_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7846 268.508C95.651 268.508 97.2063 266.997 97.2063 265.184C97.2063 263.371 95.651 261.859 93.7846 261.859C91.9183 261.859 90.3629 263.371 90.3629 265.184C90.3629 266.997 91.9183 268.508 93.7846 268.508Z",
    fill: "url(#paint82_linear_14_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.733 77.6663C140.599 77.6663 142.154 76.1553 142.154 74.3421C142.154 72.5289 140.599 71.0178 138.733 71.0178C136.866 71.0178 135.311 72.5289 135.311 74.3421C135.311 76.1553 136.866 77.6663 138.733 77.6663Z",
    fill: "url(#paint83_linear_14_1266)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7662 237.079V220.609H69.6775V236.777L55.3687 250.225V280.294L49.4586 286.036V312.176L65.3227 327.589L66.1003 326.833L50.5473 311.723V286.489L56.4575 280.747V250.678L70.7662 237.079Z",
    fill: "url(#paint84_linear_14_1266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2293 326.531V299.031L72.3215 279.69V259.895L91.2962 241.461V177.847L75.8987 162.888V141.885H74.9655V163.341L90.2074 178.3V241.159L71.2328 259.593V279.992L91.1406 299.484V326.531H92.2293Z",
    fill: "url(#paint85_linear_14_1266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.071 180.264V137.049L98.295 129.494V98.2161H97.2063V129.948L104.983 137.503V179.811L78.3872 205.801V245.54L59.7236 263.522V311.572L67.9667 319.58V327.589H69.0554V319.127L60.8123 311.119V263.975L79.3204 245.843V206.254L106.071 180.264Z",
    fill: "url(#paint86_linear_14_1266)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.75 270.774V253.095L150.086 234.963V211.996L97.5173 160.923V142.187H96.5842V161.377L148.998 212.449V235.417L167.661 253.549V270.774H168.75Z",
    fill: "url(#paint87_linear_14_1266)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.426 292.382V266.695L99.8503 256.42V200.059H97.6729V257.326L108.404 267.601V291.626L94.8733 304.772V327.589H96.8952V305.528L110.426 292.382Z",
    fill: "url(#paint88_linear_14_1266)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.868 247.656V206.858H128.934V247.203L115.87 259.895V304.017L107.316 312.176V329.251H108.404V312.63L116.803 304.47L116.959 260.348L129.868 247.656Z",
    fill: "url(#paint89_linear_14_1266)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.153 276.516V258.535L109.493 219.853V194.921L128.468 176.487V115.744L139.199 105.469V90.8121H137.022V104.562L126.446 114.837V175.58L107.316 194.166V220.76L147.131 259.291V275.761L138.577 283.92V328.949H140.755V284.827L149.153 276.516Z",
    fill: "url(#paint90_linear_14_1266)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.176 253.247V186.611L112.759 155.937V120.579H110.582V156.844L142.154 187.366V252.34L127.379 266.695V327.589H129.557V267.45L144.176 253.247Z",
    fill: "url(#paint91_linear_14_1266)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.486 113.326V90.8121H150.398V112.873L135 127.983V171.198H136.089V128.436L151.486 113.326Z",
    fill: "url(#paint92_linear_14_1266)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.257 312.932V235.417L171.705 213.356V173.767L155.686 158.204V142.489H154.597V158.657L170.616 174.22V213.809L193.324 235.719V312.479L179.015 326.38V331.215H180.104V326.682L194.257 312.932Z",
    fill: "url(#paint93_linear_14_1266)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.252 300.088V234.661L215.254 227.861V192.353L167.506 146.115V83.5591L177.149 74.1908L176.371 73.4353L166.417 83.1058L166.573 146.418L214.165 192.806V228.315L221.164 235.114V299.635L215.876 304.621V330.309H216.964V305.075L222.252 300.088Z",
    fill: "url(#paint94_linear_14_1266)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.926 182.984V129.343H176.993V182.531L156.774 202.174V272.588L133.756 294.8V329.251H134.845V295.253L157.707 272.89V202.628L177.926 182.984Z",
    fill: "url(#paint95_linear_14_1266)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1441 222.724C71.2328 222.724 72.1659 221.817 72.1659 220.76C72.1659 219.702 71.2328 218.795 70.1441 218.795C69.0554 218.795 68.1222 219.702 68.1222 220.76C68.1222 221.817 69.0554 222.724 70.1441 222.724Z",
    fill: "url(#paint96_linear_14_1266)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5876 143.849C76.6764 143.849 77.6095 142.942 77.6095 141.885C77.6095 140.827 76.6764 139.92 75.5876 139.92C74.4989 139.92 73.5657 140.827 73.5657 141.885C73.5657 142.942 74.4989 144 75.5876 143.849Z",
    fill: "url(#paint97_linear_14_1266)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5174 144.604C98.6061 144.604 99.5392 143.698 99.5392 142.64C99.5392 141.582 98.6061 140.676 97.5174 140.676C96.4286 140.676 95.4955 141.582 95.4955 142.64C95.4955 143.698 96.4286 144.604 97.5174 144.604Z",
    fill: "url(#paint98_linear_14_1266)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.02 93.0786C152.108 93.0786 153.042 92.1721 153.042 91.1144C153.042 90.0567 152.108 89.15 151.02 89.15C149.775 89.15 148.998 90.0566 148.998 91.2654C148.998 92.4743 149.931 93.2298 151.02 93.2298V93.0786Z",
    fill: "url(#paint99_linear_14_1266)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.467 173.314C136.711 173.314 137.644 172.407 137.489 171.349C137.489 170.292 136.555 169.385 135.467 169.385C134.378 169.385 133.445 170.292 133.445 171.349C133.445 172.407 134.378 173.314 135.467 173.314Z",
    fill: "url(#paint100_linear_14_1266)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.063 144.907C156.308 144.907 157.085 144 157.085 142.942C157.085 141.885 156.152 140.978 155.063 140.978C153.975 140.978 153.042 141.885 153.042 142.942C153.042 144 153.975 144.907 155.063 144.907Z",
    fill: "url(#paint101_linear_14_1266)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.506 148.533C168.595 148.533 169.528 147.626 169.528 146.569C169.528 145.511 168.595 144.604 167.506 144.604C166.417 144.604 165.484 145.511 165.484 146.569C165.484 147.626 166.417 148.533 167.506 148.533Z",
    fill: "url(#paint102_linear_14_1266)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M149.309 236.625C150.398 236.625 151.331 235.719 151.331 234.661C151.331 233.603 150.398 232.697 149.309 232.697C148.065 232.697 147.287 233.603 147.131 234.661C147.131 235.87 148.065 236.777 149.309 236.777V236.625Z",
    fill: "url(#paint103_linear_14_1266)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.87 262.011C116.959 262.011 117.892 261.104 117.892 260.046C117.892 258.989 116.959 258.082 115.87 258.082C114.781 258.082 113.848 258.989 113.848 260.046C113.848 261.104 114.781 262.011 115.87 262.011Z",
    fill: "url(#paint104_linear_14_1266)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.674 180.113C91.9183 180.113 92.6959 179.207 92.6959 178.149C92.6959 177.091 91.7627 176.185 90.674 176.185C89.5853 176.185 88.6522 177.091 88.6522 178.149C88.6522 179.207 89.5853 180.264 90.674 180.264V180.113Z",
    fill: "url(#paint105_linear_14_1266)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.09 208.974C130.179 208.974 131.112 208.067 131.112 207.009C131.112 205.952 130.179 205.045 129.09 205.045C128.001 205.045 127.068 205.952 127.068 207.009C127.068 208.067 128.001 208.974 129.09 208.974Z",
    fill: "url(#paint106_linear_14_1266)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M171.083 215.773C172.172 215.773 173.105 214.867 173.105 213.809C173.105 212.751 172.172 211.845 171.083 211.845C169.994 211.845 169.061 212.751 169.061 213.809C169.061 215.018 169.994 215.925 171.083 215.773Z",
    fill: "url(#paint107_linear_14_1266)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M193.324 237.532C194.412 237.532 195.346 236.625 195.346 235.568C195.346 234.51 194.412 233.603 193.324 233.603C192.235 233.603 191.302 234.51 191.302 235.568C191.302 236.625 192.235 237.532 193.324 237.532Z",
    fill: "url(#paint108_linear_14_1266)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M176.993 75.3997C178.082 75.3997 179.015 74.4931 179.015 73.4354C179.015 72.3777 178.082 71.4711 176.993 71.4711C175.904 71.4711 174.971 72.3777 174.971 73.4354C174.971 74.4931 175.904 75.3997 176.993 75.3997Z",
    fill: "url(#paint109_linear_14_1266)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M177.304 131.761C178.393 131.761 179.326 130.854 179.326 129.796C179.326 128.739 178.393 127.832 177.304 127.832C176.215 127.832 175.282 128.739 175.282 129.796C175.282 130.854 176.215 131.761 177.304 131.761Z",
    fill: "url(#paint110_linear_14_1266)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.661 271.379C168.75 271.379 169.839 270.472 169.683 269.415C169.683 268.357 168.75 267.45 167.661 267.45C166.573 267.45 165.639 268.357 165.639 269.415C165.639 270.472 166.573 271.379 167.661 271.379Z",
    fill: "url(#paint111_linear_14_1266)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.782 314.594C108.871 314.594 109.804 313.687 109.804 312.63C109.804 311.572 108.871 310.665 107.782 310.665C106.538 310.665 105.605 311.572 105.605 312.63C105.605 313.687 106.538 314.594 107.627 314.594H107.782Z",
    fill: "url(#paint112_linear_14_1266)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M157.241 204.441C158.33 204.441 159.263 203.534 159.263 202.476C159.263 201.419 158.33 200.512 157.241 200.512C156.152 200.512 155.219 201.419 155.219 202.628C155.219 203.836 156.152 204.592 157.241 204.592V204.441Z",
    fill: "url(#paint113_linear_14_1266)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8538 208.067C79.9425 208.067 80.8757 207.161 80.8757 206.103C80.8757 205.045 79.9425 204.139 78.8538 204.139C77.765 204.139 76.8319 205.045 76.8319 206.103C76.8319 207.161 77.765 208.067 78.8538 208.067Z",
    fill: "url(#paint114_linear_14_1266)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1464 252.793C57.2351 252.793 58.1683 251.887 58.1683 250.829C58.1683 249.771 57.2351 248.865 56.1464 248.865C55.0577 248.865 54.1245 249.771 54.1245 250.829C54.1245 251.887 55.0577 252.793 56.1464 252.793Z",
    fill: "url(#paint115_linear_14_1266)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9252 288.302C51.0139 288.302 51.9471 287.396 51.9471 286.338C51.9471 285.28 51.0139 284.374 49.9252 284.374C48.8365 284.374 47.9033 285.28 47.9033 286.338C47.9033 287.396 48.8365 288.302 49.9252 288.302Z",
    fill: "url(#paint116_linear_14_1266)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9252 313.99C51.1694 313.99 51.9471 313.083 51.9471 312.025C51.9471 310.968 51.0139 310.061 49.9252 310.061C48.8365 310.061 47.9033 310.968 47.9033 312.025C47.9033 313.083 48.8365 313.99 49.9252 313.99Z",
    fill: "url(#paint117_linear_14_1266)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8791 313.536C60.9678 313.536 61.901 312.63 61.901 311.572C61.901 310.514 60.9678 309.608 59.8791 309.608C58.7904 309.608 57.8572 310.514 57.8572 311.572C57.8572 312.63 58.7904 313.536 59.8791 313.536Z",
    fill: "url(#paint118_linear_14_1266)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8549 281.654C72.9437 281.654 73.8768 280.747 73.8768 279.538C73.8768 278.33 72.9437 277.574 71.8549 277.574C70.7662 277.574 69.833 278.481 69.833 279.538C69.833 280.596 70.7662 281.503 71.8549 281.503V281.654Z",
    fill: "url(#paint119_linear_14_1266)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.674 243.274C91.9183 243.274 92.6959 242.367 92.6959 241.31C92.6959 240.252 91.7627 239.345 90.674 239.345C89.5853 239.345 88.6522 240.252 88.6522 241.31C88.6522 242.367 89.5853 243.274 90.674 243.274Z",
    fill: "url(#paint120_linear_14_1266)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6729 100.785C98.7616 100.785 99.6948 99.8781 99.6948 98.8204C99.6948 97.7627 98.7616 96.8561 97.6729 96.8561C96.5842 96.8561 95.651 97.7627 95.651 98.8204C95.651 99.8781 96.5842 100.785 97.6729 100.785Z",
    fill: "url(#paint121_linear_14_1266)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M111.671 123.601C113.381 123.601 114.626 122.392 114.626 120.73C114.626 119.068 113.381 117.859 111.671 117.859C109.96 117.859 108.715 119.219 108.715 120.73C108.715 122.241 109.96 123.601 111.671 123.601Z",
    fill: "url(#paint122_linear_14_1266)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9171 203.081C100.628 203.081 101.872 201.872 101.872 200.21C101.872 198.548 100.628 197.339 98.9171 197.339C97.2063 197.339 95.9621 198.548 95.9621 200.21C95.9621 201.872 97.2063 203.081 98.9171 203.081Z",
    fill: "url(#paint123_linear_14_1266)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0727 259.895C100.628 259.895 102.028 258.686 102.028 257.024C102.028 255.362 100.628 254.153 99.0727 254.153C97.5174 254.153 96.1176 255.362 96.1176 257.024C96.1176 258.686 97.5174 259.895 99.0727 259.895Z",
    fill: "url(#paint124_linear_14_1266)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.266 93.2297C139.977 93.2297 141.221 92.0209 141.221 90.3588C141.221 88.6966 139.977 87.4878 138.266 87.4878C136.555 87.4878 135.311 88.6966 135.311 90.3588C135.311 92.0209 136.711 93.2297 138.266 93.2297Z",
    fill: "url(#paint125_linear_14_1266)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5911 312.479C54.5911 315.047 52.4137 317.314 49.6141 317.314C46.9701 317.314 44.6372 315.198 44.6372 312.479C44.6372 309.759 46.8146 307.643 49.6141 307.643C52.4137 307.643 54.5911 309.759 54.5911 312.479ZM45.5703 312.479C45.5703 314.745 47.4367 316.407 49.6141 316.407C51.7915 316.407 53.6579 314.594 53.6579 312.479C53.6579 310.363 51.7915 308.55 49.6141 308.55C47.4367 308.55 45.5703 310.363 45.5703 312.479Z",
    fill: "url(#paint126_linear_14_1266)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5911 286.489C54.5911 289.058 52.4137 291.324 49.6141 291.324C46.8146 291.324 44.6372 289.209 44.6372 286.489C44.6372 283.769 46.8146 281.654 49.6141 281.654C52.4137 281.654 54.5911 283.769 54.5911 286.489ZM45.5703 286.489C45.5703 288.756 47.4367 290.418 49.6141 290.418C51.7915 290.418 53.6579 288.604 53.6579 286.489C53.6579 284.374 51.7915 282.56 49.6141 282.56C47.4367 282.56 45.5703 284.374 45.5703 286.489Z",
    fill: "url(#paint127_linear_14_1266)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6568 251.131C60.6568 253.7 58.4793 255.967 55.6798 255.967C52.8803 255.967 50.7029 253.851 50.7029 251.131C50.7029 248.411 52.8803 246.296 55.6798 246.296C58.4793 246.296 60.6568 248.411 60.6568 251.131ZM51.636 251.131C51.636 253.398 53.5024 255.06 55.6798 255.06C57.8572 255.06 59.7236 253.247 59.7236 251.131C59.7236 249.016 57.8572 247.203 55.6798 247.203C53.5024 247.203 51.636 249.016 51.636 251.131Z",
    fill: "url(#paint128_linear_14_1266)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M74.81 220.911C74.81 223.48 72.6326 225.746 69.833 225.746C67.0335 225.746 64.8561 223.631 64.8561 220.911C64.8561 218.191 67.0335 216.076 69.833 216.076C72.6326 216.076 74.81 218.191 74.81 220.911ZM65.7893 220.911C65.7893 223.026 67.6556 224.84 69.833 224.84C72.0105 224.84 73.8768 223.026 73.8768 220.911C73.8768 218.796 72.0105 216.982 69.833 216.982C67.6556 216.982 65.7893 218.796 65.7893 220.911Z",
    fill: "url(#paint129_linear_14_1266)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9874 279.69C76.9874 282.258 74.81 284.525 72.0105 284.525C69.211 284.525 67.0335 282.409 67.0335 279.69C67.0335 276.97 69.211 274.854 72.0105 274.854C74.81 274.854 76.9874 276.97 76.9874 279.69ZM67.9667 279.69C67.9667 281.805 69.8331 283.618 72.0105 283.618C74.1879 283.618 76.0542 281.805 76.0542 279.69C76.0542 277.574 74.1879 275.761 72.0105 275.761C69.8331 275.761 67.9667 277.574 67.9667 279.69Z",
    fill: "url(#paint130_linear_14_1266)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80.098 142.036C80.098 144.604 77.9206 146.871 75.1211 146.871C72.3215 146.871 70.1441 144.756 70.1441 142.036C70.1441 139.316 72.3215 137.2 75.1211 137.2C77.9206 137.2 80.098 139.316 80.098 142.036ZM71.0773 142.036C71.0773 144.302 72.9436 145.964 75.1211 145.964C77.2985 145.964 79.1648 144.151 79.1648 142.036C79.1648 139.92 77.2985 138.107 75.1211 138.107C72.9436 138.107 71.0773 139.92 71.0773 142.036Z",
    fill: "url(#paint131_linear_14_1266)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M172.483 269.263C172.483 271.983 170.305 274.099 167.506 274.099C164.862 274.099 162.529 271.983 162.529 269.263C162.529 266.544 164.706 264.428 167.506 264.428C170.15 264.428 172.483 266.544 172.483 269.263ZM163.462 269.263C163.462 271.379 165.328 273.192 167.506 273.192C169.683 273.192 171.55 271.379 171.55 269.263C171.55 267.148 169.683 265.335 167.506 265.335C165.328 265.335 163.462 267.148 163.462 269.263Z",
    fill: "url(#paint132_linear_14_1266)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M198.456 235.266C198.456 237.985 196.279 240.101 193.479 240.101C190.835 240.101 188.502 237.985 188.502 235.266C188.502 232.546 190.68 230.43 193.479 230.43C196.279 230.43 198.456 232.546 198.456 235.266ZM189.436 235.266C189.436 237.381 191.302 239.194 193.479 239.194C195.657 239.194 197.523 237.381 197.523 235.266C197.523 233.15 195.657 231.337 193.479 231.337C191.302 231.337 189.436 233.15 189.436 235.266Z",
    fill: "url(#paint133_linear_14_1266)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M160.04 142.489C160.04 145.058 157.863 147.324 155.063 147.324C152.264 147.324 150.086 145.209 150.086 142.489C150.086 139.769 152.264 137.654 155.063 137.654C157.863 137.654 160.04 139.769 160.04 142.489ZM151.02 142.489C151.02 144.604 152.886 146.418 155.063 146.418C157.241 146.418 159.107 144.604 159.107 142.489C159.107 140.374 157.241 138.56 155.063 138.56C152.886 138.56 151.02 140.374 151.02 142.489Z",
    fill: "url(#paint134_linear_14_1266)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M181.504 73.1332C181.504 75.702 179.326 77.9685 176.527 77.9685C173.727 77.9685 171.55 75.8531 171.55 73.1332C171.55 70.4134 173.727 68.298 176.527 68.298C179.326 68.298 181.504 70.4134 181.504 73.1332ZM172.483 73.1332C172.483 75.3998 174.349 77.0619 176.527 77.0619C178.704 77.0619 180.57 75.2487 180.57 73.1332C180.57 71.0178 178.704 69.2046 176.527 69.2046C174.349 69.2046 172.483 71.0178 172.483 73.1332Z",
    fill: "url(#paint135_linear_14_1266)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M182.126 129.343C182.126 132.063 179.948 134.178 177.149 134.178C174.349 134.178 172.172 132.063 172.172 129.343C172.172 126.623 174.349 124.508 177.149 124.508C179.948 124.508 182.126 126.623 182.126 129.343ZM173.105 129.343C173.105 131.458 174.971 133.272 177.149 133.272C179.326 133.272 181.192 131.458 181.192 129.343C181.192 127.228 179.326 125.414 177.149 125.414C174.971 125.414 173.105 127.228 173.105 129.343Z",
    fill: "url(#paint136_linear_14_1266)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M155.374 91.2654C155.374 93.532 153.508 95.3452 151.175 95.3452C148.842 95.3452 146.976 93.532 146.976 91.2654C146.976 88.9989 148.842 87.1857 151.175 87.1857C153.508 87.1857 155.374 88.9989 155.374 91.2654ZM147.754 91.2654C147.754 93.0787 149.309 94.5897 151.175 94.5897C153.042 94.5897 154.597 93.0787 154.597 91.2654C154.597 89.4522 153.042 87.9412 151.175 87.9412C149.309 87.9412 147.754 89.4522 147.754 91.2654Z",
    fill: "url(#paint137_linear_14_1266)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101.717 98.6695C101.717 100.936 99.8503 102.749 97.5174 102.749C95.1844 102.749 93.3181 100.936 93.3181 98.6695C93.3181 96.403 95.1844 94.5897 97.5174 94.5897C99.8503 94.5897 101.717 96.403 101.717 98.6695ZM94.0957 98.6695C94.0957 100.483 95.651 101.994 97.5174 101.994C99.3837 101.994 100.939 100.483 100.939 98.6695C100.939 96.8563 99.3837 95.3452 97.5174 95.3452C95.651 95.3452 94.0957 96.8563 94.0957 98.6695Z",
    fill: "url(#paint138_linear_14_1266)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M101.561 142.338C101.561 144.604 99.6948 146.418 97.3618 146.418C95.0289 146.418 93.1625 144.604 93.1625 142.338C93.1625 140.071 95.0289 138.258 97.3618 138.258C99.6948 138.258 101.561 140.071 101.561 142.338ZM93.9402 142.338C93.9402 144.151 95.4955 145.662 97.3618 145.662C99.2282 145.662 100.783 144.151 100.783 142.338C100.783 140.525 99.2282 139.014 97.3618 139.014C95.4955 139.014 93.9402 140.525 93.9402 142.338Z",
    fill: "url(#paint139_linear_14_1266)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M105.916 257.477C105.916 261.104 102.961 263.975 99.2282 263.975C95.4955 263.975 92.5404 261.104 92.5404 257.477C92.5404 253.851 95.4955 250.98 99.2282 250.98C102.961 250.98 105.916 253.851 105.916 257.326V257.477ZM93.7846 257.477C93.7846 260.348 96.2731 262.766 99.2282 262.766C102.183 262.766 104.672 260.348 104.672 257.477C104.672 254.607 102.183 252.189 99.2282 252.189C96.1176 252.189 93.7846 254.607 93.7846 257.477Z",
    fill: "url(#paint140_linear_14_1266)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M105.916 200.361C105.916 203.987 102.961 206.858 99.2282 206.858C95.4955 206.858 92.5404 203.987 92.5404 200.361C92.5404 196.735 95.4955 193.864 99.2282 193.864C102.961 193.864 105.916 196.735 105.916 200.21V200.361ZM93.7846 200.361C93.7846 203.232 96.2731 205.65 99.2282 205.65C102.183 205.65 104.672 203.232 104.672 200.361C104.672 197.49 102.183 195.072 99.2282 195.072C96.2731 195.072 93.7846 197.49 93.7846 200.361Z",
    fill: "url(#paint141_linear_14_1266)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M118.203 120.579C118.203 124.055 115.248 127.077 111.515 127.077C107.782 127.077 104.827 124.206 104.827 120.579C104.827 116.953 107.782 114.082 111.515 114.233C115.092 114.233 118.203 117.104 118.203 120.579ZM106.072 120.579C106.072 123.45 108.56 125.868 111.515 125.868C114.47 125.868 116.959 123.45 116.959 120.579C116.959 117.708 114.47 115.291 111.515 115.291C108.56 115.291 106.072 117.708 106.072 120.579Z",
    fill: "url(#paint142_linear_14_1266)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M145.265 90.661C145.265 94.1363 142.31 97.1583 138.577 97.1583C134.845 97.1583 131.889 94.2874 131.889 90.8121C131.889 87.3367 134.845 84.3147 138.577 84.3147C142.31 84.3147 145.265 87.1856 145.265 90.8121V90.661ZM133.134 90.661C133.134 93.5319 135.622 95.9496 138.577 95.9496C141.532 95.9496 144.021 93.5319 144.021 90.661C144.021 87.79 141.532 85.3724 138.577 85.3724C135.622 85.3724 133.134 87.79 133.134 90.661Z",
    fill: "url(#paint143_linear_14_1266)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_1266",
    x1: 18.9748,
    y1: 11.937,
    x2: 18.9748,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_1266",
    x1: 52.5692,
    y1: 11.937,
    x2: 52.5692,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_1266",
    x1: 54.28,
    y1: 11.9369,
    x2: 54.28,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_1266",
    x1: 131.267,
    y1: 11.9369,
    x2: 131.267,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_1266",
    x1: 84.9194,
    y1: 11.937,
    x2: 84.9194,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_1266",
    x1: 109.649,
    y1: 11.9371,
    x2: 109.649,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_1266",
    x1: 124.58,
    y1: 11.937,
    x2: 124.58,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_1266",
    x1: 123.18,
    y1: 11.937,
    x2: 123.18,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14_1266",
    x1: 147.754,
    y1: 11.937,
    x2: 147.754,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14_1266",
    x1: 196.123,
    y1: 11.937,
    x2: 196.123,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14_1266",
    x1: 226.918,
    y1: 11.9369,
    x2: 226.918,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14_1266",
    x1: 167.35,
    y1: 11.9369,
    x2: 167.35,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14_1266",
    x1: 34.6832,
    y1: 11.9358,
    x2: 34.6832,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14_1266",
    x1: 42.9263,
    y1: 11.9365,
    x2: 42.9263,
    y2: 412.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14_1266",
    x1: 76.9874,
    y1: 11.9364,
    x2: 76.9874,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14_1266",
    x1: 159.729,
    y1: 11.9369,
    x2: 159.729,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14_1266",
    x1: 135.778,
    y1: 11.9376,
    x2: 135.778,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14_1266",
    x1: 165.951,
    y1: 11.9374,
    x2: 165.951,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14_1266",
    x1: 185.392,
    y1: 11.9364,
    x2: 185.392,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14_1266",
    x1: 157.085,
    y1: 11.7847,
    x2: 157.085,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14_1266",
    x1: 105.294,
    y1: 11.9381,
    x2: 105.294,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14_1266",
    x1: 66.4114,
    y1: 11.9377,
    x2: 66.4114,
    y2: 412.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14_1266",
    x1: 125.824,
    y1: 11.9378,
    x2: 125.824,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14_1266",
    x1: 190.835,
    y1: 11.9378,
    x2: 190.835,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14_1266",
    x1: 225.207,
    y1: 11.9381,
    x2: 225.207,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14_1266",
    x1: 199.856,
    y1: 11.9369,
    x2: 199.856,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_14_1266",
    x1: 200.478,
    y1: 11.9366,
    x2: 200.478,
    y2: 412.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_14_1266",
    x1: 185.547,
    y1: 11.9355,
    x2: 185.547,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_14_1266",
    x1: 92.8515,
    y1: 11.9385,
    x2: 92.8515,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_14_1266",
    x1: 169.528,
    y1: 11.936,
    x2: 169.528,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_14_1266",
    x1: 48.0588,
    y1: 11.9378,
    x2: 48.0588,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_14_1266",
    x1: 12.7536,
    y1: 11.938,
    x2: 12.7536,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_14_1266",
    x1: 3.26618,
    y1: 11.7872,
    x2: 3.26618,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_14_1266",
    x1: 3.26625,
    y1: 11.7842,
    x2: 3.26625,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_14_1266",
    x1: 18.6636,
    y1: 11.7873,
    x2: 18.6636,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_14_1266",
    x1: 37.3273,
    y1: 11.9383,
    x2: 37.3273,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_14_1266",
    x1: 66.4114,
    y1: 11.938,
    x2: 66.4114,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_14_1266",
    x1: 77.2985,
    y1: 11.9369,
    x2: 77.2985,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_14_1266",
    x1: 98.7616,
    y1: 11.9369,
    x2: 98.7616,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_14_1266",
    x1: 79.0093,
    y1: 11.937,
    x2: 79.0093,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_14_1266",
    x1: 79.1648,
    y1: 11.9361,
    x2: 79.1648,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_14_1266",
    x1: 139.977,
    y1: 11.937,
    x2: 139.977,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_14_1266",
    x1: 49.3031,
    y1: 11.9369,
    x2: 49.3031,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_14_1266",
    x1: 74.0323,
    y1: 11.9369,
    x2: 74.0323,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_14_1266",
    x1: 75.2765,
    y1: 11.9368,
    x2: 75.2765,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_14_1266",
    x1: 132.201,
    y1: 11.9369,
    x2: 132.201,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_14_1266",
    x1: 97.9839,
    y1: 11.9369,
    x2: 97.9839,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_14_1266",
    x1: 116.181,
    y1: 11.9369,
    x2: 116.181,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_14_1266",
    x1: 127.379,
    y1: 11.937,
    x2: 127.379,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_14_1266",
    x1: 126.29,
    y1: 11.937,
    x2: 126.29,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_14_1266",
    x1: 144.487,
    y1: 11.937,
    x2: 144.487,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_14_1266",
    x1: 180.259,
    y1: 11.937,
    x2: 180.259,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_14_1266",
    x1: 202.967,
    y1: 11.9369,
    x2: 202.967,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_14_1266",
    x1: 158.952,
    y1: 11.937,
    x2: 158.952,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_14_1266",
    x1: 60.8122,
    y1: 11.9375,
    x2: 60.8122,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_14_1266",
    x1: 67.0334,
    y1: 11.9372,
    x2: 67.0334,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_14_1266",
    x1: 92.0738,
    y1: 11.9372,
    x2: 92.0738,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_14_1266",
    x1: 153.353,
    y1: 11.9371,
    x2: 153.353,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_14_1266",
    x1: 135.622,
    y1: 11.9373,
    x2: 135.622,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_14_1266",
    x1: 157.863,
    y1: 11.9358,
    x2: 157.863,
    y2: 412.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_14_1266",
    x1: 172.172,
    y1: 11.9364,
    x2: 172.172,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_14_1266",
    x1: 151.331,
    y1: 11.9359,
    x2: 151.331,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_14_1266",
    x1: 113.07,
    y1: 11.9358,
    x2: 113.07,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_14_1266",
    x1: 84.2973,
    y1: 11.7852,
    x2: 84.2973,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_14_1266",
    x1: 128.157,
    y1: 11.9375,
    x2: 128.157,
    y2: 412.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_14_1266",
    x1: 176.371,
    y1: 11.9375,
    x2: 176.371,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_14_1266",
    x1: 201.722,
    y1: 11.9387,
    x2: 201.722,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_14_1266",
    x1: 183.059,
    y1: 11.9371,
    x2: 183.059,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_14_1266",
    x1: 183.37,
    y1: 11.9359,
    x2: 183.37,
    y2: 412.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_14_1266",
    x1: 172.483,
    y1: 11.9376,
    x2: 172.483,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_14_1266",
    x1: 103.894,
    y1: 11.7866,
    x2: 103.894,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_14_1266",
    x1: 160.507,
    y1: 11.936,
    x2: 160.507,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_14_1266",
    x1: 70.6107,
    y1: 11.9385,
    x2: 70.6107,
    y2: 412.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_14_1266",
    x1: 44.6372,
    y1: 11.7864,
    x2: 44.6372,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_14_1266",
    x1: 37.6383,
    y1: 11.9377,
    x2: 37.6383,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_14_1266",
    x1: 37.6383,
    y1: 11.9337,
    x2: 37.6383,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_14_1266",
    x1: 48.992,
    y1: 11.9393,
    x2: 48.992,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_14_1266",
    x1: 62.6786,
    y1: 11.9376,
    x2: 62.6786,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_14_1266",
    x1: 84.2973,
    y1: 11.7864,
    x2: 84.2973,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_14_1266",
    x1: 92.2293,
    y1: 11.937,
    x2: 92.2293,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_14_1266",
    x1: 108.249,
    y1: 11.9372,
    x2: 108.249,
    y2: 412.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_14_1266",
    x1: 93.6291,
    y1: 11.9358,
    x2: 93.6291,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_14_1266",
    x1: 93.7846,
    y1: 11.9377,
    x2: 93.7846,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_14_1266",
    x1: 138.733,
    y1: 11.9369,
    x2: 138.733,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_14_1266",
    x1: 60.0347,
    y1: 11.9369,
    x2: 60.0347,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_14_1266",
    x1: 81.8088,
    y1: 11.937,
    x2: 81.8088,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_14_1266",
    x1: 82.8975,
    y1: 11.9369,
    x2: 82.8975,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_14_1266",
    x1: 132.667,
    y1: 11.9368,
    x2: 132.667,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_14_1266",
    x1: 102.65,
    y1: 11.9369,
    x2: 102.65,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_14_1266",
    x1: 118.669,
    y1: 11.937,
    x2: 118.669,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_14_1266",
    x1: 128.312,
    y1: 11.9369,
    x2: 128.312,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_14_1266",
    x1: 127.379,
    y1: 11.937,
    x2: 127.379,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_14_1266",
    x1: 143.243,
    y1: 11.9369,
    x2: 143.243,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_14_1266",
    x1: 174.505,
    y1: 11.9368,
    x2: 174.505,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_14_1266",
    x1: 194.412,
    y1: 11.9368,
    x2: 194.412,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_14_1266",
    x1: 155.841,
    y1: 11.937,
    x2: 155.841,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_14_1266",
    x1: 70.1441,
    y1: 11.9382,
    x2: 70.1441,
    y2: 412.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_14_1266",
    x1: 75.5876,
    y1: 11.9377,
    x2: 75.5876,
    y2: 412.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_14_1266",
    x1: 97.5173,
    y1: 11.9377,
    x2: 97.5173,
    y2: 412.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_14_1266",
    x1: 151.02,
    y1: 11.9368,
    x2: 151.02,
    y2: 412.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_14_1266",
    x1: 135.467,
    y1: 11.7869,
    x2: 135.467,
    y2: 412.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_14_1266",
    x1: 155.063,
    y1: 11.9377,
    x2: 155.063,
    y2: 412.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_14_1266",
    x1: 167.506,
    y1: 11.9358,
    x2: 167.506,
    y2: 412.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_14_1266",
    x1: 149.309,
    y1: 11.9365,
    x2: 149.309,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_14_1266",
    x1: 115.87,
    y1: 11.7874,
    x2: 115.87,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_14_1266",
    x1: 90.8296,
    y1: 11.9365,
    x2: 90.8296,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_14_1266",
    x1: 129.09,
    y1: 11.9352,
    x2: 129.09,
    y2: 412.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_14_1266",
    x1: 171.083,
    y1: 11.9353,
    x2: 171.083,
    y2: 412.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_14_1266",
    x1: 193.324,
    y1: 11.7872,
    x2: 193.324,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_14_1266",
    x1: 176.993,
    y1: 11.9369,
    x2: 176.993,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_14_1266",
    x1: 177.304,
    y1: 11.9376,
    x2: 177.304,
    y2: 412.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_14_1266",
    x1: 167.661,
    y1: 11.9347,
    x2: 167.661,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_14_1266",
    x1: 107.782,
    y1: 11.9388,
    x2: 107.782,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_14_1266",
    x1: 157.241,
    y1: 11.9366,
    x2: 157.241,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_14_1266",
    x1: 78.8538,
    y1: 11.9382,
    x2: 78.8538,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_14_1266",
    x1: 56.1464,
    y1: 11.9349,
    x2: 56.1464,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_14_1266",
    x1: 49.9252,
    y1: 11.9345,
    x2: 49.9252,
    y2: 412.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_14_1266",
    x1: 49.9252,
    y1: 11.7834,
    x2: 49.9252,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_14_1266",
    x1: 59.8791,
    y1: 11.7877,
    x2: 59.8791,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_14_1266",
    x1: 71.8549,
    y1: 11.9365,
    x2: 71.8549,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_14_1266",
    x1: 90.8296,
    y1: 11.935,
    x2: 90.8296,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_14_1266",
    x1: 97.6729,
    y1: 11.9361,
    x2: 97.6729,
    y2: 412.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_14_1266",
    x1: 111.671,
    y1: 11.9377,
    x2: 111.671,
    y2: 412.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_14_1266",
    x1: 98.9171,
    y1: 11.9364,
    x2: 98.9171,
    y2: 412.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_14_1266",
    x1: 98.9171,
    y1: 11.9362,
    x2: 98.9171,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_14_1266",
    x1: 138.266,
    y1: 11.9366,
    x2: 138.266,
    y2: 412.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_14_1266",
    x1: 49.6141,
    y1: 11.9371,
    x2: 49.6141,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_14_1266",
    x1: 49.6141,
    y1: 11.9372,
    x2: 49.6141,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_14_1266",
    x1: 55.6798,
    y1: 11.9372,
    x2: 55.6798,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_14_1266",
    x1: 69.833,
    y1: 11.9372,
    x2: 69.833,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_14_1266",
    x1: 72.0105,
    y1: 11.9372,
    x2: 72.0105,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_14_1266",
    x1: 75.1211,
    y1: 11.9371,
    x2: 75.1211,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_14_1266",
    x1: 167.506,
    y1: 11.9357,
    x2: 167.506,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_14_1266",
    x1: 193.479,
    y1: 11.9359,
    x2: 193.479,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_14_1266",
    x1: 155.063,
    y1: 11.937,
    x2: 155.063,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_14_1266",
    x1: 176.527,
    y1: 11.937,
    x2: 176.527,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_14_1266",
    x1: 177.304,
    y1: 11.937,
    x2: 177.304,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_14_1266",
    x1: 151.175,
    y1: 11.9368,
    x2: 151.175,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_14_1266",
    x1: 97.5174,
    y1: 11.9368,
    x2: 97.5174,
    y2: 412.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_14_1266",
    x1: 97.3618,
    y1: 11.9366,
    x2: 97.3618,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_14_1266",
    x1: 99.2282,
    y1: 11.9367,
    x2: 99.2282,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_14_1266",
    x1: 99.2282,
    y1: 11.9368,
    x2: 99.2282,
    y2: 412.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_14_1266",
    x1: 111.671,
    y1: 11.9371,
    x2: 111.671,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_14_1266",
    x1: 138.577,
    y1: 11.937,
    x2: 138.577,
    y2: 412.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignHomeLines);
export default __webpack_public_path__ + "static/media/design-home-lines.e029919a9216a85045257d866a40f946.svg";
export { ForwardRef as ReactComponent };